import {
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  TextField,
  Typography,
  Tooltip
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  Autocomplete,
  ToggleButton,
  ToggleButtonGroup
} from '@material-ui/lab';
import { AddCircleOutline as AddIcon, Delete } from '@material-ui/icons';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Rule from './Rule';
import { useDispatch, useSelector } from 'react-redux';
import { SkeletonCardFields } from 'components/Loading';
import { getConditionQueries } from 'store/conditionQueryTemplate/actions';
import { mapExpressionFromResposne } from 'store/helpers';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import { cleanStyle, throttle, addDragElementStyle, retainStyleForSeconds, scrollController, removeDragElementStyle, dragOverStyle } from 'views/Campaign/helpers/dragAndDropHelper'
import { useDebounce } from 'helpers';
import shortid from 'shortid';
let draggedId = null;
let draggedRule = null;
let draggedPosition = null;
let draggedfromId = null;
let draggedTemplateId = null;
let draggedParentId = [];
const removeIconStyles = t => ({
  removeButton: {
    marginRight: t.spacing(-1),
    marginTop: t.spacing(0.75)
  },
  removeIcon: {
    fill: 'rgba(255, 0, 0, 0.9)'
  }
});

const useRuleGroupStyles = makeStyles(t => ({
  actionButton: {
    marginRight: t.spacing(0.5),
    marginTop: t.spacing(0.25)
  },
  conditionOperator: {
    height: 36,
    padding: t.spacing(0, 1.5)
  },
  group: {
    height: 'calc(50% + 8px)',
    borderLeft: props => (props.level ? `2px dotted rgb(155 155 155)` : 'none'),
    paddingLeft: t.spacing(1.5),
    marginBottom: t.spacing(0.5),
    marginTop: props => (props.level > 0 ? t.spacing(0.5) : 'none')
  },
  containerMargin: {
    marginLeft: t.spacing(1),
    marginTop: '10px',
    marginBottom: '10px'
  },
  autoCompleteContainer: {
    display: 'inline',
    minWidth: '14rem',
    margin: t.spacing(1),
    marginTop: t.spacing(2)
  },
  buttonContainer: {
    display: 'inline',
    paddingTop: '12px'
  },
  borderStyle: {
    height: '15px',
    borderBottom: '2px dotted #43a047',
  },
  ...removeIconStyles(t)
}));

const RuleGroup = props => {
  const classes = useRuleGroupStyles(props);
  const {
    conditionOperator,
    operators,
    context,
    id,
    level,
    subConditionExpressions,
    template,
    isReadOnly,
    ruleParent,
    parentRulePosition
  } = props;
  const testId = `group-${level}`;
  const { dispatch, maxLevels } = context;
  const dispatchAction = useDispatch();
  const [isDraggingOverPosition, setIsDraggingOverPosition] = useState(null);
  const [isDraggingOver, setIsDraggingOver] = useState(null);
  const [isDraggingOverEmpty, setIsDraggingOverEmpty] = useState(null);
  const dragOverId = useDebounce(isDraggingOver, 500);
  const gettingQueryData = useSelector(
    store => store.conditionQueryTemplate.gettingQueryData
  );
  const conditionExpression = useSelector(
    store => store.conditionQueryTemplate.conditionExpression
  );

  useEffect(() => {
    const nextElement = isDraggingOverPosition > 0 ? subConditionExpressions[isDraggingOverPosition - 1] : null;
    dragOverStyle(nextElement, dragOverId);
    return () => {
      if (dragOverId) {
        cleanStyle(dragOverId, nextElement);
      }
    };
  }, [dragOverId]);

  useEffect(() => {
    let schemaIdentifier =
      template.thisTemplate.productCategory +
      '.' +
      template.thisTemplate.productName +
      '.' +
      template.thisTemplate.eventTypeCategory;
    dispatchAction(
      getConditionQueries({
        data: { schemaIdentifier: schemaIdentifier },
        force: true
      })
    );
  }, []);

  const getValidConditionExpression = () => {
    return template.thisTemplate.subscriberListId !== '' ? conditionExpression.filter(exp => {
      return exp.subscriberListId === template.thisTemplate.subscriberListId;
    }) : conditionExpression;
  };

  const getConditionQuery = (rule, position) => {
    return gettingQueryData ? (
      <Grid container spacing={0} xs={5}>
        <SkeletonCardFields />
      </Grid>
    ) : (
      <Card className={classes.containerMargin}>
        <CardContent>
          <Grid container >
            <Grid item className={classes.autoCompleteContainer}>
              {
                <Autocomplete
                  name="conditionAttribute"
                  id="condition-Attribute"
                  size="small"
                  onChange={(event, values) => {
                    dispatch({
                      type: 'addQuery',
                      id,
                      level: level + 1,
                      queryId: rule.queryId,
                      queryData: mapExpressionFromResposne(
                        values.conditionExpression, template.attributes
                      )
                    });
                  }}
                  disabled={false}
                  options={getValidConditionExpression() || []}
                  getOptionLabel={option => option.name}
                  style={{ width: 229 }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Select Condition Query"
                      variant="outlined"
                      required
                    />
                  )}
                />
              }
            </Grid>
            {!isReadOnly() && (
              <>
                <Grid item className={classes.buttonContainer}>
                  <Tooltip title="Delete">
                    <IconButton
                      className={classes.removeButton}
                      data-testid={`rule-${testId}-remove`}
                      size="small"
                      onClick={() => {
                        dispatch({
                          type: 'removeConditionQuery',
                          id,
                          queryId: rule.queryId
                        });
                      }}>
                      <Delete className={classes.removeIcon} />
                    </IconButton>
                  </Tooltip>
                </Grid>
                <Grid item className={classes.buttonContainer} style={{ paddingLeft: '15px' }} draggable={true}
                  onDragStart={(event) => { event.stopPropagation(); handleDragStart(rule, position, id) }}
                  onDragEnd={(event) => { event.stopPropagation(); handleDragEnd() }} >
                  <Tooltip title="Drag">
                    <IconButton
                      className={classes.removeButton}
                      data-testid={`rule-${testId}-remove`}
                      size="small"
                      title='Drag to reorder'
                      style={{ cursor: 'move' }}
                    >
                      <DragIndicatorIcon style={{ color: '#43a047' }} />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </>
            )}
          </Grid>
        </CardContent>
      </Card>
    );
  };

  const handleDragStart = (rule, position = 0, fromId) => {
    let ruleId = rule?.id || rule?.queryId;
    addDragElementStyle(ruleId);
    draggedfromId = fromId;
    draggedId = ruleId;
    draggedRule = rule;
    draggedPosition = position;
    draggedParentId = rule?.parentIds;
    draggedTemplateId = template?.templateId
  };

  function isCorrectDroppableIndex(fromId, parentIds) {
    return ((draggedParentId?.length === 0 && !ruleParent) ||
      draggedParentId?.includes(fromId) || parentIds?.includes(draggedfromId) || draggedfromId == fromId);
  }

  function isDroppable(parentIds, fromId, ruleid) {
    return (draggedId && !parentIds?.includes(draggedId) && !ruleParent?.parentIds.includes(draggedId)
      && draggedId != fromId && (ruleid != draggedId));
  }

  const handleDrop = async (e, ruleId, type, position, parentIds, fromId) => {
    e.preventDefault();
    e.stopPropagation();
    if (draggedTemplateId != template?.templateId) {
      return;
    }
    let isConditionQuery = (type && type == 'conditionQuery');

    setIsDraggingOver(null);
    setIsDraggingOverPosition(null);
    setIsDraggingOverEmpty(false);
    //check right index when having same parent
    if (isCorrectDroppableIndex(fromId, parentIds)) {
      if (position == draggedPosition + 1) return;
      else if (draggedPosition < position) { position = position - 1; }
    }
    if (isDroppable(parentIds, fromId, ruleId)) {

      if (draggedRule.type === 'conditionQuery') {
        await dispatch({ type: 'removeConditionQuery', id: draggedfromId, queryId: draggedRule.queryId });
      } else {
        await dispatch({ type: 'removeNode', id: draggedId });
      }
      await dispatch({
        type: 'addRemovedNode',
        id: (isConditionQuery || (subConditionExpressions?.length == 0 || position)) ? id : ruleId,
        rule: draggedRule,
        position: position,
        level: level + 1,
        findNode: (isConditionQuery || (subConditionExpressions?.length == 0 || position))
      });
    }
    //remove dragged element color
    retainStyleForSeconds(draggedId);
    resetDraggedVariables();
  };
  
  const throttledDragLeave = (event) => {
    setIsDraggingOverEmpty(false);
    setIsDraggingOver(null);
    setIsDraggingOverPosition(null);
  };

  function handleDragLeave(event) {
    event.preventDefault();
    event.stopPropagation();
    throttle(throttledDragLeave(event), 1000);
  }

  const throttledDragOver = (event, position, parentIds, ruleid, fromId) => {
    if ((isCorrectDroppableIndex(fromId, parentIds)
      && position == draggedPosition + 1)) {
      return;
    }
    else if (isDroppable(parentIds, fromId, ruleid)) {
      if (subConditionExpressions?.length == 0) {
        setIsDraggingOverEmpty(true);
        setIsDraggingOver(null);
        setIsDraggingOverPosition(null); return;
      }
      else if (position > subConditionExpressions?.length - 1) {
        setIsDraggingOverPosition(position);
        return;
      }
      setIsDraggingOver(ruleid);
      setIsDraggingOverPosition(position);
    }
  };

  function handleDragOver(event, position, parentIds, ruleid, fromId) {
    event.preventDefault();
    event.stopPropagation();
    scrollController(event);
    if (draggedTemplateId != template?.templateId) {
      return;
    }
    throttle(throttledDragOver(event, position, parentIds, ruleid, fromId), 1000);
  }

  const handleDragEnd = () => {
    removeDragElementStyle(draggedId);
    setIsDraggingOverEmpty(false);
    setIsDraggingOver(null);
    setIsDraggingOverPosition(null);
    resetDraggedVariables();
  };

  const resetDraggedVariables = () => {
    draggedId = null;
    draggedRule = null;
    draggedPosition = null;
    draggedfromId = null;
    draggedParentId = [];
    draggedTemplateId = null;
  };
  return level <= maxLevels ? (
    <Grid
      container
      className={classes.group}
      data-testid={testId}
      direction="column"
      spacing={1}>
      <Grid item>
        <Grid container spacing={2}>
          <Grid item>
            <ToggleButtonGroup
              exclusive
              size="small"
              value={conditionOperator}
              onChange={(event, value) => {
                if (value) {
                  dispatch({ type: 'setConditionOperator', id, value });
                }
              }}>
              {operators.map(item => (
                <ToggleButton
                  key={item.value}
                  data-testid={`${testId}-conditionOperator-${item.value}`}
                  className={classes.conditionOperator}
                  disabled={isReadOnly()}
                  value={item.value}>
                  <Typography variant="body2">{item.label}</Typography>
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Grid>
          {!isReadOnly() && (
            <Grid item>
              <Button
                className={classes.actionButton}
                color="primary"
                data-testid={`${testId}-add-rule`}
                disabled={isReadOnly()}
                onClick={() => {
                  dispatch({ type: 'addRule', id, level: level + 1 });
                }}>
                <AddIcon />
                Rule
              </Button>
            </Grid>
          )}
          {!isReadOnly() && level < maxLevels && (
            <Grid item>
              <Button
                className={classes.actionButton}
                color="primary"
                data-testid={`${testId}-add-group`}
                disabled={isReadOnly()}
                onClick={() => {
                  dispatch({ type: 'addGroup', id, level: level + 1 });
                }}>
                <AddIcon />
                Group
              </Button>
            </Grid>
          )}
          {!isReadOnly() && level < maxLevels && (
            <Grid item>
              <Button
                className={classes.actionButton}
                color="primary"
                data-testid={`${testId}-add-query`}
                disabled={isReadOnly()}
                onClick={() => {
                  dispatch({
                    type: 'addConditionQuery',
                    id,
                    queryId: shortid.generate(),
                    level: level + 1
                  });
                }}>
                <AddIcon />
                Query
              </Button>
            </Grid>
          )}
          {!isReadOnly() && (
            <>
              <Grid item >
                <Tooltip title="Delete">
                  <IconButton
                    className={classes.removeButton}
                    data-testid={`${testId}-remove`}
                    disabled={level === 0}
                    size="small"
                    onClick={() => {
                      dispatch({ type: 'removeNode', id });
                    }}>
                    {level > 0 && (
                      <Delete className={level > 0 ? classes.removeIcon : null} />
                    )}
                  </IconButton>
                </Tooltip>
                {level > 0 && <Grid item className={classes.buttonContainer} style={{ paddingLeft: '15px' }} draggable={true}
                  onDragStart={(event) => {
                    event.stopPropagation();
                    handleDragStart(ruleParent, parentRulePosition, id)
                  }}
                  onDragEnd={(e) => { e.stopPropagation(); handleDragEnd() }}>
                  <Tooltip title="Drag">
                    <IconButton
                      className={classes.removeButton}
                      data-testid={`rule-${testId}-remove`}
                      size="small"
                      title='Drag to reorder'
                      style={{ cursor: 'move' }}
                    >
                      <DragIndicatorIcon style={{ color: '#43a047' }} />
                    </IconButton>
                  </Tooltip>
                </Grid>}
              </Grid></>
          )}
        </Grid>
      </Grid>

      {
        subConditionExpressions?.length == 0 && <div
          className={classes.borderStyle}
          onDragOver={(event) => {  handleDragOver(event, 0, ruleParent?.parentIds, id) }}
          onDragLeave={(event) => { handleDragLeave(event); }}
          onDrop={(event) => { handleDrop(event, null, null, 0, ruleParent?.parentIds); }}
          style={{
            opacity: isDraggingOverEmpty ? 1 : 0,
          }}
        >
        </div>
      }

      {subConditionExpressions?.length > 0 && (
        <Grid item>
          {subConditionExpressions.map((rule, position) => {
            return (
              <>
                <div id={rule.id || rule.queryId} key={rule.id || rule.queryId}
                  style={{ border: '2px dotted transparent' }}
                  onDragLeave={(event) => {  handleDragLeave(event, position) }}
                  onDragOver={(event) => {
                    handleDragOver(event, position, rule.parentIds, rule.id || rule.queryId, id)
                  }}
                  onDrop={(event) => {
                    handleDrop(event, rule.id || rule.queryId, rule?.type, position, rule.parentIds, id);
                  }} >
                  {rule.type === 'conditionQuery' ? (
                    getConditionQuery(rule, position)
                  ) : (
                    <Rule
                      key={rule.id}
                      id={rule.id}
                      level={level}
                      position={position}
                      rule={rule}
                      context={context}
                      template={template}
                      isReadOnly={isReadOnly}
                      handleDragEnd={handleDragEnd}
                      handleDragStart={handleDragStart}
                      baseRuleId={id}
                    />
                  )}
                </div>
                {position == subConditionExpressions.length - 1 &&
                  <div
                    className={classes.borderStyle}
                    onDragLeave={(event) => { handleDragLeave(event, position + 1) }}
                    onDragOver={(event) => {
                      handleDragOver(event, position + 1, ruleParent?.parentIds, id)
                    }}
                    onDrop={(event) => {
                      handleDrop(event, rule.id || rule.queryId, rule?.type, position + 1, rule.parentIds, id);
                    }}
                    style={{
                      opacity: (isDraggingOverPosition == position + 1) ? 1 : 0
                    }}
                  >
                  </div>}
              </>);
          }

          )}
        </Grid>
      )}
    </Grid>
  ) : (
    <span />
  );
};

RuleGroup.defaultProps = {
  conditionOperator: 'AND',
  operators: [
    { label: 'AND', value: 'AND' },
    { label: 'OR', value: 'OR' }
  ],
  subConditionExpressions: []
};

RuleGroup.propTypes = {
  conditionOperator: PropTypes.string,
  operators: PropTypes.array,
  id: PropTypes.number.isRequired,
  level: PropTypes.number.isRequired,
  subConditionExpressions: PropTypes.array
};

export default RuleGroup;
